import api from '@/services/Api';
import { ActionContext, Module } from 'vuex';
import Leistung from '@/types/Leistung';
import { errorSwal, successSwal } from '@/helper/swals';
import { AxiosResponse } from 'axios';
import { LeistungenState, RootState } from '@/store/types';

export type LeistungenFilter = { gueltig: string };
export type LoadLeistungenPayload = { filter: LeistungenFilter };
export type UpdateLeistungPayload = { leistung: Leistung; filter: LeistungenFilter };
export type DeleteLeistungPayload = { leistung: Leistung; filter: LeistungenFilter };

type Context = ActionContext<LeistungenState, RootState>;

export const leistungen: Module<LeistungenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            leistungen: false,
        },
        leistungen: [],
    },
    actions: {
        loadLeistungen({ commit }: Context, payload: LoadLeistungenPayload): void {
            commit('setLoadersLeistungen', true);
            commit('setLeistungen', []);

            api.post('verwaltung/leistungen/load', payload)
                .then((response) => commit('setLeistungen', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersLeistungen', false));
        },
        updateLeistung({ commit, dispatch }: Context, { leistung, filter }: UpdateLeistungPayload): void {
            commit('setLoadersSave', true);

            api.post('verwaltung/leistungen/speichern', leistung)
                .then(() => {
                    successSwal('Leistung', 'gespeichert');
                    dispatch('loadLeistungen', { filter });
                    commit('setDialogsDetail', false);
                })
                .catch(console.error)
                .finally(() => commit('setLoadersSave', false));
        },
        deleteLeistung({ commit, dispatch }: Context, { leistung, filter }: DeleteLeistungPayload): void {
            commit('setLoadersDelete', true);

            api.post('verwaltung/leistungen/loeschen', leistung)
                .then((response: AxiosResponse) => {
                    if (response.data.body) {
                        successSwal('Leistung', 'gelöscht');
                        dispatch('loadLeistungen', { filter });
                        commit('setDialogsDetail', false);
                    } else {
                        errorSwal(
                            'Fehler',
                            'Diese Leistung kann nicht gelöscht werden da sie bereits verwendet wurde.',
                        );
                    }
                })
                .catch(console.error)
                .finally(() => commit('setLoadersDelete', false));
        },
    },
    mutations: {
        setLeistungen(state: LeistungenState, leistungen: Leistung[]): void {
            state.leistungen = leistungen;
        },
        setDialogsDetail(state: LeistungenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: LeistungenState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: LeistungenState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersLeistungen(state: LeistungenState, loading: boolean): void {
            state.loaders.leistungen = loading;
        },
    },
    getters: {
        getVerwaltungsabgabe: (state: LeistungenState): Leistung | undefined => {
            return state.leistungen.find((leistung) => leistung.leistung === 'Verwaltungsabgabe');
        },
    },
};
